// extracted by mini-css-extract-plugin
export default {"Box__menu":"Menu_Box__menu__CBQE9","menu":"Menu_menu__iMQEZ","menu__block":"Menu_menu__block__fOIzZ"};